import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AlertService } from '../../../../app/utils/alert.service';
import { AuthenticationService } from '../../../../app/services/authentication.service';
import { BindComponentService } from '../../../../app/utils/bind.component.service';

  import * as _ from "lodash";
import { SyncListComponent } from './synclist/content.component';

/**
 * @version $Id$
 */
@Component({
  selector: 'vivosync',
  templateUrl: './content.template.html'
})

export class VivoSyncComponent implements OnInit {

  public linkAtual: string;
  
  public hasData: boolean = false;
  public totalGroups: number;
  private loggedManagerType: string;

  @ViewChild('syncListComp')
  public syncListComponent: SyncListComponent;

  constructor(private bindComponent: BindComponentService, private authenticationService: AuthenticationService, private alertService: AlertService) {

  }

  ngOnInit() {
    this.bindComponent.set(BindComponentService.FILTER_ACTIVE_TAB, 'VIVO_SYNC_FILTER'); //ALTERADO
    setTimeout(() => {
        document.getElementById('vivoSync').classList.add('active');
        let data  = JSON.parse(localStorage.getItem('GET_AUTENTICATED_USER'));
      
        this.hasData = data['isData'];
        this.bindComponent.subscribe(BindComponentService.TOTAL_GROUPS,
          total => {
            this.totalGroups = total;
          }
        );
    }, 3000);   
  }

  public isGestorCompany():boolean{
    let authenticatedUser  = JSON.parse(localStorage.getItem('GET_AUTENTICATED_USER'));
    if(!_.isNil(authenticatedUser)){
      this.loggedManagerType = authenticatedUser['loggedManagerType'];
      if (this.loggedManagerType === 'COMPANY_MANAGER' || this.loggedManagerType === 'COMPANY_MASTER_MANAGER') {
        return  authenticatedUser['showB2B2CFuncionality'];
      } else {
        return false;
      }
    }  
    return false;
  }
}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/vivosync/content.component.ts